module.exports = __webpack_public_path__ + "static/media/intervencion2.ce50e340.webp";